import axios from "axios";

const Login_Api = axios.create({
  baseURL: "https://test.simplaxi.com/api/login/",
});

export default Login_Api;
